
<div class="admission-banner">
  <div class="admission-content">

    <div class="banner-header">
      <h1 class="admission-title">ADMISSION</h1>
      <h2 class="admission-subtitle">OPEN 2025-26</h2>
      <p class="admission-tagline">Unlock your child's potential with Sehyog Academy</p>
    </div>
    
    <div class="admission-programs">
      <div class="program">
        <h3 class="program-title">11plus Admission</h3>
        <p class="program-desc">Take the Assessment Test & Win Scholarships</p>
        <a href="https://zfrmz.in/CXWHedw5dEnsTL7d361m" class="learn-more">Apply Now</a>
      </div>
      
    </div>
  </div>
  
  <div class="admission-image">
    <img src="assets/images/admi-open.png" alt="Students ready for admission">
  </div>
</div>


<!-- Section 2 -->

<div class="course-panel">
  <div class="panel-header">
    <div class="header-line"></div>
    <h2 class="panel-section-title">Our Courses</h2>
  </div>
  
  <div class="course-card">
    <div class="card-content">
      <div class="course-info">
        <h3 class="course-title">11<span class="plus">plus</span></h3>
        <h4 class="course-subtitle">Admission</h4>
        
        <p class="course-desc">Take the Assessment Test & Win Scholarships</p>
        
        <ul class="scholarship-list">
          <li>
            <span class="medal">🥇</span> 1st Rank - 75% OFF
          </li>
          <li>
            <span class="medal">🥈</span> 2nd Rank - 50% OFF
          </li>
          <li>
            <span class="medal">🥉</span> 3rd Rank - 25% OFF
          </li>
        </ul>
        
        <a href="https://zfrmz.in/CXWHedw5dEnsTL7d361m" class="apply-button">Apply Now</a>
      </div>
      
      <div class="course-image">
        <img src="assets/images/gcse-mobile-bg.jpg" alt="Student taking exam">
      </div>
    </div>
  </div>

  <div class="course-card">
    <div class="card-content">
      <div class="course-info">
        <h3 class="course-title">Summer Intensive</h3>
        <h4 class="course-subtitle">Course (SIC 2025)</h4>
        
        <p class="course-desc">10 Days of Power-Packed Revision: Mock Tests, Strategies, Feedback, and More!</p>
        
        <a [routerLink]="['/rapid-course']" class="apply-button">Book Now</a>
      </div>
      
      <div class="course-image">
        <img src="assets/images/cc_img.png" alt="Student taking exam">
      </div>
    </div>
  </div>

</div>

<!-- section 4 -->

<div class="testimonials-section">
  <div class="testimonials-banner">
    <div class="section-header-testimonials">
      <div class="header-line-testimonials"></div>
      <h2 class="section-title"></h2>
    </div>
    
    <div class="testimonials-heading">
      <h1 class="main-heading"> <span>What</span> <br>Parents Say About Us?</h1>
    </div>
    
    <div class="testimonials-container">
      <!-- Testimonial 1 -->
      <div class="testimonial-card">
        <div class="avatar-circle">
          <span class="initials">JR</span>
        </div>
        <h5 class="tm-name">Jaya Rani</h5>
        <p class="testimonial-text">
          My son did Sehyog Mock Test, it's very helpful to know which areas my son is lacking. Sehyog result analysis gives us understanding on which area the aspirant/parent needs to improve and concentrate on, which is very important in 11 plus journey, apart from that Sehyog also provides you guidance on how to submit CAF form with the school preferences and clarified most of our doubts. Thank you so much Sehyog team for your all your efforts.
        </p>
      </div>
      
      <!-- Testimonial 2 -->
      <div class="testimonial-card">
        <div class="avatar-circle">
          <span class="initials">AD</span>
        </div>
        <h5 class="tm-name">Asima Dar</h5>
        <p class="testimonial-text">
         My son got admission in KEGS. Thank you so much SEHYOG. Your mocks were awesome; and my son learnt a lot because of these mocks. I am thinking that if my son didn't do these mocks, he may not have got admission in KEGS...Thank you again SEHYOG family!
        </p>
      </div>
      
      <!-- Testimonial 3 -->
      <div class="testimonial-card">
        <div class="avatar-circle">
          <span class="initials">MD</span>
        </div>
        <h5 class="tm-name">Mini Dagar</h5>
        <p class="testimonial-text">
          My son attended the mock exams by 11plushelpclub and it helped us a lot. With the detailed results every week, we knew which area to work on. Topic wise tests were a great form of revision. All the help by whole team was fabulous which helped my son to secure a safe place at school of his choice. Big thanks to everyone out there for all the help and guidance - Mini Dagar
        </p>
      </div>
    </div>
  </div>
</div>


<!-- section 3 -->


<div class="why-choose-section">
  <div class="section-banner">

    <div class="section-overlay">

      <div class="section-header">
        <div class="header-line"></div>
        <h2 class="section-title"></h2>
      </div>

      <div class="whyc-container">

        <div class="choose-content">
        <h1 class="choose-heading">Why <br> <span>Choose Us?</span></h1>
        <p class="choose-tagline">Trusted by over 10K+ Parents & Students</p>
      </div>

      <div class="feature-cards">
      <div class="feature-card">
        <div class="card-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#0077b6">
            <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm4 3H8v-.5C8 15.33 10.67 14 12 14s4 1.33 4 2.5V17z"/>
          </svg>
        </div>
        <h3 class="card-title">Best Teachers</h3>
        <p class="card-text">
          Good tutors teach you, but the best tutors prepare you for the future. They don't just give knowledge; they shape your skills for success.
        </p>
      </div>
      
      <div class="feature-card">
        <div class="card-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#0077b6">
            <path d="M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"/>
          </svg>
        </div>
        <h3 class="card-title">Best Curriculum</h3>
        <p class="card-text">
          Good tutors teach you, but the best tutors prepare you for the future. They don't just give knowledge; they shape your skills for success.
        </p>
      </div>
      
      <div class="feature-card">
        <div class="card-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#0077b6">
            <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
          </svg>
        </div>
        <h3 class="card-title">Assessment & Feedback</h3>
        <p class="card-text">
          Good tutors teach you, but the best tutors prepare you for the future. They don't just give knowledge; they shape your skills for success.
        </p>
      </div>
    </div>
      
    </div>
    
    
        
    </div>
      
      

  </div>
</div>



<!-- section 5 -->

<div class="contact-container">
        <div class="contact-info">
            <h1 class="contact-heading"><span>Contact</span> Us</h1>
            <div class="contact-details">
                <p class="contact-line">Hotline: (0)2039808244</p>
                <p class="contact-line">Email: support&#64;sehyog.co.uk</p>
                <p class="contact-line">WhatsApp: +44 7464772331</p>
            </div>
        </div>
        <div class="contact-image">
            <img src="assets/images/ct-us.jpg" alt="Customer Service Representative">
        </div>
    </div>

